// Funções utilitárias para o aplicativo

/**
 * Gera uma string aleatória de tamanho especificado
 * @param length - Tamanho da string a ser gerada
 * @returns String aleatória
 */
export function generateRandomString(length: number): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

/**
 * Gera um share_id único de 64 caracteres para quizzes
 * @returns Share ID de 64 caracteres
 */
export function generateShareId(): string {
  return generateRandomString(64);
}

/**
 * Valida se uma string é um share_id válido
 * @param shareId - Share ID a ser validado
 * @returns true se for válido, false caso contrário
 */
export function isValidShareId(shareId: string): boolean {
  return typeof shareId === 'string' && shareId.length === 64 && /^[a-zA-Z0-9]+$/.test(shareId);
}

/**
 * Gera um UUID único para páginas de quiz
 * Usado para tracking de analytics que não quebra com edits
 * @returns UUID v4 único
 */
export function generatePageUniqueId(): string {
  return crypto.randomUUID()
}